// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3TR7j","messages":"Chat_messages__27CYg","dateDivider":"Chat_dateDivider__2XwD9"};